import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isNullOrUndefined } from 'intact-shared';
import { createContext } from '../context';
export var context = createContext();
export function useSearchable() {
  var menu = useInstance();
  var select = menu.select;
  var checkedKeys = useState([]);
  function selectAll() {
    checkedKeys.set(addKeys(checkedKeys.value, menu.get('values')));
  }
  function unselectAll() {
    checkedKeys.set(removeKeys(checkedKeys.value, menu.get('values')));
  }
  function toggleSelect() {
    var checked = [];
    var unchecked = [];
    menu.get('values').forEach(function (item) {
      if (checkedKeys.value.indexOf(item) > -1) {
        checked.push(item);
      } else {
        unchecked.push(item);
      }
    });
    checkedKeys.set(removeKeys(addKeys(checkedKeys.value, unchecked), checked));
  }
  function confirm() {
    select.set('value', checkedKeys.value);
    select.hide();
  }
  function initCheckedKeys() {
    var value = select.get('value');
    checkedKeys.set(isNullOrUndefined(value) ? [] : value);
  }
  select.watch('value', initCheckedKeys);
  select.on('hide', initCheckedKeys);
  return {
    checkedKeys: checkedKeys,
    selectAll: selectAll,
    unselectAll: unselectAll,
    toggleSelect: toggleSelect,
    confirm: confirm
  };
}
function addKeys(origin, keys) {
  var _context;
  return _Array$from(new _Set(_concatInstanceProperty(_context = []).call(_context, keys, origin || [])));
}
function removeKeys(origin, keys) {
  var _context2;
  return _filterInstanceProperty(_context2 = origin || []).call(_context2, function (item) {
    return keys.indexOf(item) < 0;
  });
}